import { render, staticRenderFns } from "./CustomerSelect.vue?vue&type=template&id=789fcf1c&scoped=true"
import script from "./CustomerSelect.vue?vue&type=script&lang=js"
export * from "./CustomerSelect.vue?vue&type=script&lang=js"
import style0 from "./CustomerSelect.vue?vue&type=style&index=0&id=789fcf1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789fcf1c",
  null
  
)

export default component.exports